import PropTypes from "prop-types";
import { useContext } from 'react';
import { ProductContext } from "@/core/providers/ProductContext";
import SectionWidget from "@/pages/products/detailWidgets/SectionWidget";
import { kebabCase } from "@/helpers/kebabCase";

const ProductDetailBlade = ({ stepKey }) => {

    const {product} = useContext(ProductContext);

    try {
        
        const section = product.sections.find((section) => section.label === stepKey);
        const name = kebabCase(section.label)
        return <div key={name}>
            <SectionWidget section={section} name={name} />
        </div>
    } catch (e) {
        return <></>;
    }

};

ProductDetailBlade.propTypes = {
    stepKey: PropTypes.string
};

export default ProductDetailBlade;
